import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/admin/admin.service';
import { LoaderService } from 'src/app/utils/loader.service';

interface DialogData {

}

@Component({
  selector: 'app-bidding-final-confirmation',
  templateUrl: './bidding-final-confirmation.component.html',
  styleUrls: ['./bidding-final-confirmation.component.scss']
})
export class BiddingFinalConfirmationComponent implements OnInit {

  enquiryId;

  constructor(
    public dialogref: MatDialogRef<BiddingFinalConfirmationComponent>,
    private adminService: AdminService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private toastr: ToastrService,
    private loaderService: LoaderService
  ) { }

  ngOnInit() {
    this.enquiryId = this.data["data"];
  }

  close() {
    this.dialogref.close(false);
  }

  submit() {
    this.loaderService.display(true);
    this.adminService.submitLiveEnquiry(this.enquiryId, this.data["termsData"]).subscribe(
      (res: any) => {
        this.toastr.success(res.message, 'Success');
        this.loaderService.display(false);
        this.dialogref.close(true);

      },

      (err: any) => {
        this.toastr.error(err.error.message, 'Error');
        this.loaderService.display(false);
        this.dialogref.close(true);
      }
    )
  }

}
